<template>
    <Tooltip
        :canOpen="canOpen"
        :delay="delay"
        :wrapperClass="wrapperClass"
        :arrowBorderColor="
            contrastBorder ? 'border-tooltip-border-inverted' : 'border-primary'
        "
    >
        <template #trigger>
            <slot />
        </template>
        <template #content>
            <div
                :class="[
                    { 'ring-tooltip-border': !contrastBorder },
                    { 'ring-tooltip-border-inverted': contrastBorder },
                    maxWidth,
                    'bg-tooltip ring-1 py-1 px-3 font-medium text-tooltip-text shadow w-max',
                    roundedClass,
                ]"
            >
                <p v-html="text" />
            </div>
        </template>
    </Tooltip>
</template>

<script>
import Tooltip from '@/Components/Elements/Tooltip.vue'

export default {
    components: {
        Tooltip,
    },

    props: {
        text: {
            type: String,
            required: true,
        },
        canOpen: {
            type: Boolean,
            default: true,
        },
        delay: {
            type: Number,
            default: 500,
        },
        wrapperClass: {
            type: String,
        },
        contrastBorder: {
            type: Boolean,
            default: false,
        },
        maxWidth: {
            type: String,
            default: 'max-w-64',
        },
        roundedClass: {
            type: String,
            default: 'rounded-lg',
        },
    },
}
</script>
